module.exports = __webpack_public_path__ + "img/assortment.cf3fdfb7.svg";